import React from 'react'

import { Text } from '../../../../components/presentation/Text'
import FlexGrid, { FlexCol } from '../../../../components/structure/FlexGrid'
import Replies from '../replies/Replies'
import PlacePresenter from '../../../../containers/places/PlacePresenter'
import LabelValue from '../../../../components/presentation/LabelValue'
import Panel from '../../../../packages/kiti/components/structure/Panel'

const Event = ({ item }) => {
  const { serviceOrder, formReply, reply } = item
  const checklist = serviceOrder?.checklist || formReply?.form?.checklist
  const categoryName = reply?.question?.category?.name || formReply?.question?.category?.name

  return (
    <FlexGrid justify="flex-start">
      <FlexCol flex={3}>
        <Text size="xsmall">{item.serviceOrder?.yearlyId || item.formReply?.form?.name}</Text>
        <Text bold>{checklist?.name}</Text>
        <Text size="xsmall">{categoryName}</Text>
      </FlexCol>

      <FlexCol flex={2}>
        <LabelValue label="Local/Pessoa">
          <PlacePresenter place={item.serviceOrder?.place || item.formReply?.place} weight="500" />
        </LabelValue>
      </FlexCol>
    </FlexGrid>
  )
}

const Wrapper = ({ startsOpen, item, ...props }) => (
  <Panel noMargin mediumPadding lineBorder noShadow flex={1} {...props}>
    <Event item={item} {...props} />
    <Replies mainReply={item.reply} />
  </Panel>
)

export default Wrapper
